<template>
    <div class="bg-white shadow-sm py-3 h-100" style="border-radius: 20px;">
        <div class="d-flex align-items-center">
            <div class="px-4 ml-auto">زیر مجموعه های جدید
            </div>
            <div class="px-4">
                <router-link class="text-success" to="/marketing/subsets">مشاهده کل</router-link>
            </div>
        </div>
        <hr>
        <div v-if="status === 'ok' && settlements.data.length > 0">
            <div :key="index" v-for="(settlement , index) in settlements.data">
                <div class="px-3 my-4 d-flex align-items-center">
                    <div class="ml-auto d-flex align-items-center">
                        <div class="pr-3">{{ settlement.full_name }}</div>
                    </div>
                    <div class="pl-3"><b>{{ settlement.created_at }}</b></div>
                </div>
            </div>
        </div>

        <div v-else>
            <div style="filter: blur(5px);">
                <div class="px-4 my-4 d-flex align-items-center">
                    <div class="ml-auto d-flex align-items-center">
                        <div class="border border-dark rounded-circle p-2" style="border-color: #a0a0a0 !important;">
                            <div>...</div>
                        </div>
                        <div>
                            <div class="px-4" dir="ltr">1399/12/19</div>
                            <div class="px-4 mt-2">درگاه تلفنی اول</div>
                        </div>
                    </div>
                    <div>
                        <div :class="'px-4 text-success'"><b>12,7000 ریال</b></div>
                        <div class="px-4 mt-2 text-left"><small>
                            <b>
                                تایید شده
                            </b>
                        </small></div>
                    </div>
                </div>
                <div class="px-4 my-4 d-flex align-items-center">
                    <div class="ml-auto d-flex align-items-center">
                        <div class="border border-dark rounded-circle p-2" style="border-color: #a0a0a0 !important;">
                            <div>...</div>
                        </div>
                        <div>
                            <div class="px-4" dir="ltr">1399/12/19</div>
                            <div class="px-4 mt-2">درگاه تلفنی اول</div>
                        </div>
                    </div>
                    <div>
                        <div :class="'px-4 text-success'"><b>12,7000 ریال</b></div>
                        <div class="px-4 mt-2 text-left"><small>
                            <b>
                                تایید شده
                            </b>
                        </small></div>
                    </div>
                </div>
                <div class="px-4 my-4 d-flex align-items-center">
                    <div class="ml-auto d-flex align-items-center">
                        <div class="border border-dark rounded-circle p-2" style="border-color: #a0a0a0 !important;">
                            <div>...</div>
                        </div>
                        <div>
                            <div class="px-4" dir="ltr">1399/12/19</div>
                            <div class="px-4 mt-2">درگاه تلفنی اول</div>
                        </div>
                    </div>
                    <div>
                        <div :class="'px-4 text-success'"><b>12,7000 ریال</b></div>
                        <div class="px-4 mt-2 text-left"><small>
                            <b>
                                تایید شده
                            </b>
                        </small></div>
                    </div>
                </div>
                <div class="px-4 my-4 d-flex align-items-center">
                    <div class="ml-auto d-flex align-items-center">
                        <div class="border border-dark rounded-circle p-2" style="border-color: #a0a0a0 !important;">
                            <div>...</div>
                        </div>
                        <div>
                            <div class="px-4" dir="ltr">1399/12/19</div>
                            <div class="px-4 mt-2">درگاه تلفنی اول</div>
                        </div>
                    </div>
                    <div>
                        <div :class="'px-4 text-success'"><b>12,7000 ریال</b></div>
                        <div class="px-4 mt-2 text-left"><small>
                            <b>
                                تایید شده
                            </b>
                        </small></div>
                    </div>
                </div>
                <div class="px-4 my-4 d-flex align-items-center">
                    <div class="ml-auto d-flex align-items-center">
                        <div class="border border-dark rounded-circle p-2" style="border-color: #a0a0a0 !important;">
                            <div>...</div>
                        </div>
                        <div>
                            <div class="px-4" dir="ltr">1399/12/19</div>
                            <div class="px-4 mt-2">درگاه تلفنی اول</div>
                        </div>
                    </div>
                    <div>
                        <div :class="'px-4 text-success'"><b>12,7000 ریال</b></div>
                        <div class="px-4 mt-2 text-left"><small>
                            <b>
                                تایید شده
                            </b>
                        </small></div>
                    </div>
                </div>

            </div>
            <div class="locked-overlay" v-if="status == 'loading'">
                <div style="position: absolute; width: 100%; text-align: center; top: 30%;">
                    <div class="btn btn-success mt-5">
                        <div class="d-flex justify-content-center align-items-center">
                            <div class="px-2">لطفا صبر کنید</div>
                            <div class="spinner-border spinner-border-sm text-white" role="status"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="locked-overlay" v-else-if="status == 'ok' && settlements.length == 0">
                <div style="position: absolute; width: 100%; text-align: center; top: 30%;">
                    <div>
                        <div class="btn">
                            <img src="@/assets/new/image/not-found_new.png" width="200">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {ApiService} from "@/common/api.service";
    import {statusStrForCommonAccess, statusVariantForCommonAccess} from "@/constants/settlementStatus";
    import IranSheba from "iran-sheba";

    export default {
        data() {
            return {
                settlements: null,
                statusVariantForCommonAccess,
                statusStrForCommonAccess,
                status: 'loading'
            }
        },
        async mounted() {
            let res = await ApiService.query('marketing/subsets?page=1&perpage=10', '');
            this.settlements = res.data.data;
            this.status = 'ok';

        },
        methods: {
            getBankNickname(sheba) {
                const bank = IranSheba.recognize(sheba.split("-").join(""));
                if (bank) {
                    return bank.nickname;
                }
                return "central-bank"; // default value for when this function failed to recognize the bank name
            },
        }
    }
</script>

<style scoped>

</style>